import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import dataFetcher from "../../../../../parts/chore/dataFetcher";
import { Form } from 'antd';

import { updateTaxReceiptConfigurationActivation } from '../../taxReceiptActions';

import TaxReceiptAdminConfigurationPanel from './TaxReceiptAdminConfigurationPanel';

const mapStateToProps = state => ({
  configuration: state.TaxReceipt.taxReceiptConfiguration,
  isUpdateConfigurationInProgress: state.TaxReceipt.isUpdateConfigurationInProgress,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateTaxReceiptConfigurationActivation
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  dataFetcher,
  Form.create(),
)(TaxReceiptAdminConfigurationPanel);
